import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import OrganizationForm from '../../components/crm/OrganizationForm';

export default function OrganizationCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (
    <div className="flex flex-col gap-4 pb-10">
      <OrganizationForm
        onClose={() => navigate('/crm/organizations')}
        onSaved={(id) => {
          queryClient.invalidateQueries({ queryKey: ['crm-orgs'] });
          navigate(`/crm/organizations/${id}`);
        }}
        standalone
      />
    </div>
  );
}
